import { Link } from 'react-router-dom'
import { motion } from 'framer-motion'
import ReactPlayer from 'react-player'
import clsx from 'clsx'

import { YearTopAnimes } from '../../svgs/YearTopAnimes'
import {
  getAnimeDetailsUrl,
  getAnimeImage,
} from '../../../services/util.service'
import { TrailerIcon, WatchlistIcon } from '../../ui/icons/shared'

export function TopAnimesPreview({
  anime,
  width,
  isPlaying,
  isHovered,
  isExpanded,
  onHoverEnter,
  onHoverLeave,
  onTrailerClick,
  onToggleWatch,
  isInWatchlist,
}) {
  const titleEng = anime.title_english || anime.title
  const titleHeb = anime.title_hebrew
  const fullTitle = `${titleHeb} / ${titleEng}`
  const trailerLabel = `נגן טריילר עבור ${fullTitle}`
  const watchlistLabel = isInWatchlist
    ? `הסר את ${fullTitle} מרשימת הצפייה שלך`
    : `הוסף את ${fullTitle} לרשימת הצפייה שלך`

  return (
    <motion.div
      layout
      onMouseEnter={onHoverEnter}
      onMouseLeave={onHoverLeave}
      animate={{ width }}
      transition={{ ease: 'easeInOut', duration: 0.4 }}
      className="flex flex-col items-center"
    >
      <button
        onClick={onTrailerClick}
        className="relative focus:outline-none"
        style={{ width: width, height: 350 }}
        aria-label={trailerLabel}
        title={trailerLabel}
      >
        {isPlaying ? (
          <div className="absolute inset-0">
            <ReactPlayer
              url={anime.trailer.url}
              playing
              controls
              width="100%"
              height="100%"
              config={{
                youtube: { playerVars: { rel: 0, modestbranding: 1 } },
              }}
            />
          </div>
        ) : (
          <img
            src={getAnimeImage(anime)}
            alt={`${fullTitle} – Trailer thumbnail`}
            title={trailerLabel}
            className="absolute inset-0 object-cover transition-opacity duration-300"
            style={{ width: '100%', height: '100%' }}
          />
        )}

        {!isPlaying && (
          <div
            className="absolute inset-0 flex items-center justify-center"
            aria-hidden="true"
          >
            <TrailerIcon
              className={isHovered ? 'fill-primary' : 'fill-accentLight'}
            />
          </div>
        )}
      </button>

      <div className="w-full text-center mt-2 relative">
        {isExpanded ? (
          <div
            className="absolute -translate-y-[63%] right-[3%]"
            aria-label={`Year of release: ${anime.year} for ${fullTitle}`}
            title={`Released in ${anime.year}`}
          >
            <YearTopAnimes anime={anime} />
          </div>
        ) : (
          <p className="text-sm text-muted" aria-hidden="true"></p>
        )}
      </div>

      <div className="flex justify-between w-full mt-4">
        <h3 className="text-sm md:text-md max-w-[280px] h-16">
          <Link
            to={getAnimeDetailsUrl(anime)}
            className={`hover:text-primary transition-all ${
              isExpanded ? 'text-white' : 'text-muted'
            }`}
            title={`מעבר לעמוד הפרטים של ${fullTitle}`}
            aria-label={`מידע נוסף על ${fullTitle}`}
          >
            <div className="max-w-32">
              <span>{titleHeb}</span> // <span>{titleEng}</span>
            </div>
          </Link>
        </h3>

        <button
          onClick={onToggleWatch}
          className="self-start"
          aria-label={watchlistLabel}
          title={watchlistLabel}
        >
          <WatchlistIcon
            className={clsx(
              'transition-transform duration-300 hover:fill-primary',
              isInWatchlist ? 'fill-primary' : 'fill-[#363636]'
            )}
          />
        </button>
      </div>
    </motion.div>
  )
}
